'use client';

import { c as _c } from "react/compiler-runtime";
import { AnimatedCountBadge } from '@/components/ui/animated-count-badge';
export function PortfolioActivityCount(t0) {
  const $ = _c(7);
  const {
    count,
    hasMore,
    pending
  } = t0;
  const t1 = pending ? "invisible" : undefined;
  let t2;
  if ($[0] !== count || $[1] !== hasMore) {
    t2 = <AnimatedCountBadge value={count} hasMore={hasMore} data-testid="activity-count" />;
    $[0] = count;
    $[1] = hasMore;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pending || $[4] !== t1 || $[5] !== t2) {
    t3 = <span className={t1} aria-hidden={pending}>{t2}</span>;
    $[3] = pending;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}